import { registerMixin } from '@dygc/shared'
import mixin from './condition-mixin'
import FillCondition from './FillCondition'
import DateCondition from './DateCondition'
import AddressCondition from './AddressCondition'
import CascaderCondition from './CascaderCondition'
import NumberCondition from './NumberCondition'
import SingleCondition from './SingleCondition'
import MultipleCondition from './MultipleCondition'

const conditionComponent = {
  FillCondition,
  DateCondition,
  CascaderCondition,
  SingleCondition,
  MultipleCondition,
  AddressCondition,
  NumberCondition
}

const attributeType = {
  FILL: 'input',
  SINGLE: 'select',
  MULTIPLE: 'mulSelect',
  CASCADER: 'cascader',
  ADDRESS: 'address',
  NUMBER: 'number',
  DATE: 'date'
}

const componentMap = {
  [attributeType.FILL]: FillCondition.name,
  [attributeType.DATE]: DateCondition.name,
  [attributeType.ADDRESS]: AddressCondition.name,
  [attributeType.NUMBER]: NumberCondition.name,
  [attributeType.SINGLE]: SingleCondition.name,
  [attributeType.MULTIPLE]: MultipleCondition.name,
  [attributeType.CASCADER]: CascaderCondition.name
}

registerMixin(conditionComponent, mixin)

export { conditionComponent, componentMap, attributeType }
